import { HYDRATE, createWrapper, MakeStore } from 'next-redux-wrapper';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';

import space from './space';
import site from './site';
import accounts from './accounts';
import application from './application';
import service from './service';
import membership from './membership';
import payments from './payments';
import community from './community';
import orders from './orders';

const rootReducer = combineReducers({
  space: space.reducer,
  site: site.reducer,
  accounts: accounts.reducer,
  application: application.reducer,
  service: service.reducer,
  membership: membership.reducer,
  payments: payments.reducer,
  community: community.reducer,
  orders: orders.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

let initialRootState: RootState;

const reducer = (state: any, action: any) => {
  if (action.type === HYDRATE) {
    if (state === initialRootState) {
      return {
        ...state,
        ...action.payload,
      };
    }
    return state;
  }
  return rootReducer(state, action);
};

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const initStore: MakeStore = () => {
  const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production',
  });
  initialRootState = store.getState();
  return store;
};

export const wrapper = createWrapper(initStore);
